(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/utils.js'); "use strict";

const uniqueIdGenerator = () => Math.round(Math.random() * 100000 + 1000);

svs.ui.form.utils = {
  uniqueIdGenerator
};
 })(window);